/* Peakora motion layer v1 — scroll reveals + card hover motion.
   JS-gated hiding: content is visible by default; if this script fails,
   the store still renders 100% normally. Failsafe reveals everything at 3s. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.__peakoraMotion) return;
  window.__peakoraMotion = true;

  var css = document.createElement('style');
  css.textContent = [
    /* hover motion on product cards — pure CSS, always safe */
    '.product-card, [class*="product-card"] { transition: transform .35s cubic-bezier(.2,.7,.3,1), box-shadow .35s cubic-bezier(.2,.7,.3,1); }',
    '.product-card:hover, [class*="product-card"]:hover { transform: translateY(-4px); }',
    '.product-card img, [class*="product-card"] img { transition: transform .6s cubic-bezier(.2,.7,.3,1); }',
    '.product-card:hover img, [class*="product-card"]:hover img { transform: scale(1.04); }',
    'a[href]:has(img) img { transition: transform .6s cubic-bezier(.2,.7,.3,1); }',
    /* scroll reveal states — ONLY applied when JS tags elements */
    '.pm-reveal { opacity: 0; transform: translateY(22px); transition: opacity .7s cubic-bezier(.2,.7,.3,1), transform .7s cubic-bezier(.2,.7,.3,1); }',
    '.pm-reveal.pm-in { opacity: 1; transform: none; }',
    /* IMPORTANT: never transform html/body — that breaks the chat widget's fixed pinning */
    '.pm-reveal img { will-change: transform; }'
  ].join('\n');
  document.head.appendChild(css);

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* tag targets: each top-level section's main children + product cards, skip the hero */
    var targets = [];
    document.querySelectorAll('.shopify-section').forEach(function (sec, si) {
      if (si === 0) return; /* hero: leave alone */
      var kids = sec.querySelectorAll(':scope > * , :scope > .product-card, :scope [class*="product-card"]');
      targets.push({ el: sec, delay: 0 });
    });
    document.querySelectorAll('[class*="product-card"]').forEach(function (card, i) {
      targets.push({ el: card, delay: (i % 4) * 70 });
    });

    /* hide only after tagging succeeded */
    targets.forEach(function (t) { t.el.classList.add('pm-reveal'); });
    /* de-dupe: sections already containing tagged cards just reveal together */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var delay = el.__pmDelay || 0;
          setTimeout(function () { el.classList.add('pm-in'); }, delay);
          io.unobserve(el);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (t) {
      t.el.__pmDelay = t.delay || 0;
      io.observe(t.el);
    });

    /* failsafe: everything visible within 3s no matter what */
    setTimeout(function () {
      document.querySelectorAll('.pm-reveal:not(.pm-in)').forEach(function (el) {
        el.classList.add('pm-in');
      });
    }, 3000);
  });
})();
